/**
 * Canonical Person schema data — single source of truth for structured data.
 * Used by Home, About, Now, BlogPostPage, and Projects pages.
 * Update here and it propagates everywhere automatically.
 */

export const SITE_URL = 'https://christiansen.co';

export const SOCIAL_LINKS = {
  twitter: 'https://twitter.com/bjchrist',
  linkedin: 'https://linkedin.com/in/bjchrist',
  github: 'https://github.com/bjchrist',
};

export const PERSON_SCHEMA = {
  '@type': 'Person',
  name: 'Bjarne Christiansen',
  url: SITE_URL,
  image: `${SITE_URL}/images/profile.jpg`,
  email: 'bjarne@christiansen.co',
  jobTitle: 'Founder & Technologist',
  sameAs: [SOCIAL_LINKS.twitter, SOCIAL_LINKS.linkedin, SOCIAL_LINKS.github],
  worksFor: {
    '@type': 'Organization',
    name: 'Float',
    url: 'https://float.com',
  },
  founder: [
    {
      '@type': 'Organization',
      name: 'Realm',
      url: 'https://realm.io',
      description: 'Mobile database platform (acquired by MongoDB 2019)',
    },
    {
      '@type': 'Organization',
      name: 'Cohera',
      url: 'https://cohera.io',
    },
  ],
  alumniOf: {
    '@type': 'Organization',
    name: 'Y Combinator',
    url: 'https://www.ycombinator.com',
  },
  knowsAbout: [
    'Startup Fundamentals',
    'Fundraising',
    'Database Architecture',
    'Nordic Startup Ecosystem',
    'Enterprise Software',
    'Mobile Databases',
    'Offline-First Architecture',
    'Technical Due Diligence',
    'Capital Efficiency',
    'Regulated Industries',
  ],
};
